import { type VariablesOf, graphql } from "@/data-access/graphql";
import { ShareVoiceSidebarFilterFragment } from "../fragments/segment-fragment";

export const ShareVoiceSidebarFilterSubscription = graphql(
  `
  subscription ShareVoiceSidebar($projectionFilters: FeedArticleProjectionFilter!, $categories: [ShareVoiceSidebarCategory!]) {
    shareVoiceSidebar(projectionFilters: $projectionFilters, categories: $categories) {
      ...ShareVoiceSidebarFilterFragment
    }
  }
`,
  [ShareVoiceSidebarFilterFragment],
);

export type ShareVoiceSidebarSubscriptionVariables = VariablesOf<
  typeof ShareVoiceSidebarFilterSubscription
>;
